import { render, staticRenderFns } from "./HoursFilterBreaks.vue?vue&type=template&id=eddc4934"
import script from "./HoursFilterBreaks.vue?vue&type=script&lang=js"
export * from "./HoursFilterBreaks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports